import AppHeader from '../AppHeader'
import DayJs from 'dayjs'
let utils = require('../../utils')

export default {
  name: 'company_notice_list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data: () => ({
    companyNoticeList: '',
    searchEnd: false,
    nextExist: false,
    currentPage: 0
  }),
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  components: {
    AppHeader
  },
  methods: {
    async search (addSearch) {
      let data = {}
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }

      let res = await this.$store.dispatch('GET_COMPANY_NOTICE_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })

      if (addSearch) {
        this.companyNoticeList = this.companyNoticeList.concat(res.company_notices)
      } else {
        this.companyNoticeList = res.company_notices
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
    },
    goCcompanyNoticeNew: function () {
      this.$router.push({ path: '/company_notice/new' })
    },
    goCompanyNoticeDetail: function (companyNoticeId) {
      this.$router.push({ path: '/company_notice/' + companyNoticeId + '/detail' })
    },
    goCompanyNoticeEdit: function (companyNoticeId) {
      this.$router.push({ path: '/company_notice/' + companyNoticeId + '/edit' })
    },
    companyNoticeDelete: function (companyNoticeId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('DELETE_COMPANY_NOTICE', {
          data: {
            id: companyNoticeId
          }
        })
        .then(res => {
          this.search(false)
        })
        .catch(err => console.log(err))
      }
    },
    isReleaseStatus (startDate, endDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')

      if (DayJs(today).isBefore(startDate)) {
        return '未公開'
      }
      if (DayJs(endDate).isBefore(today)) {
        return '通知期間終了'
      }
      return '通知期間中'
    },
    getColor: function (startDate, endDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')

      if (DayJs(today).isBefore(startDate)) {
        return 'color-blue'
      }
      if (DayJs(endDate).isBefore(today)) {
        return 'color-gray'
      }
      return 'color-orange'
    },
    startDateFormat (startDate) {
      return DayJs(startDate).format('YYYY年MM月DD日')
    },
    endDateFormat (endDate) {
      return DayJs(endDate).format('YYYY年MM月DD日')
    },
    isSendMail (isMailDelivery) {
      if (isMailDelivery == 1) {
        return '配信あり'
      } else {
        return '配信なし'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/company-notice-list.js